/* eslint-disable import/prefer-default-export */
export const pixelConfig = {
    appId: "1174298683499462"
}
